import { getField, updateField } from 'vuex-map-fields'

const notifications = {
  namespaced: true,
  state: {
    timeout: 3000,
    color: null,
    showNotification: false,
    text: null
  },
  getters: {
    getField
  },
  actions: {
    notifySuccess ({ commit }, { message }) {
      commit('setNotification', { message, color: 'success' })
    },
    notifyError ({ commit }, { message }) {
      commit('setNotification', { message, color: 'error' })
    },
    notifyInfo ({ commit }, { message }) {
      commit('setNotification', { message, color: 'info' })
    },
    notifyWarning ({ commit }, { message }) {
      commit('setNotification', { message, color: 'warning' })
    },
    clearNotification ({ commit }) {
      commit('clearNotification')
    }
  },
  mutations: {
    updateField,
    setNotification (state, { message, color }) {
      state.text = message
      state.color = color
      state.showNotification = true
    },
    clearNotification (state) {
      state.text = null
      state.color = null
      state.showNotification = false
    }
  }
}

export default notifications
